import Vue from "vue";
/**
 * setting
 * @method setTitle
 * @method setMsg
 * @method setBtnOk
 * @method setTag
 * @method clearText
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onClickClose
 * event
 * @event sendCallbackOk
 */
export function MarketingRegisterModalController () {
    this.title = '';
    this.msg = '';
    this.btnAcceptMarketing = '';
    this.tag = '',
    this.isAcceptMarketing = false;
    this.busModal = new Vue();

    this.callbackAcceptMarketing = null;
    this.callbackConfirmMarketing = null;
    this.callbackCancelMarketing = null;

    //#region relate modal
    this.alertModal = null;
    this.confirmModal = null;
    this.loadingModal = null;
    this.confirmMarketingModal = null;
    this.setAlertModal = function (alertModal) {
        this.alertModal = alertModal;
    };
    this.setConfirmModal = function (confirmModal) {
        this.confirmModal = confirmModal;
    };
    this.setLoadingModal = function (loadingModal) {
        this.loadingModal = loadingModal;
    };
    //#endregion relate modal

    //#region setter
    this.setTitle = function(title) {
        this.title = title;
        return this;
    };
    this.setBtnAcceptMarketing = function(btnAcceptMarketing) {
        this.btnAcceptMarketing = btnAcceptMarketing;
        return this;
    };
    this.setTag = function(tag) {
        this.tag = tag;
        return this;
    };
    this.setAcceptMarketing = function(accept) {
        this.isAcceptMarketing = accept;
        return this;
    };
    this.clearText = function() {
        this.title = '';
        this.btnAcceptMarketing = '';
        this.tag = '';
        this.isAcceptMarketing = false;
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        var config = {
            title: this.title,
            msg: this.msg,
            btnAcceptMarketing: this.btnAcceptMarketing,
            tag: this.tag,
            isAcceptMarketing: this.isAcceptMarketing
        };
        this.busModal.$emit('show', config);
    };
    this.hide = function() {
        this.busModal.$emit('hide');
    };
    //#endregion method

    //#region event
    this.onAcceptMarketing = function(callback) {
        if (typeof callback == 'function') {
            this.callbackAcceptMarketing = callback;
        }
    };
    this.sendCallbackAcceptMarketing = function(data) {
        if (typeof this.callbackAcceptMarketing == 'function') {
            this.callbackAcceptMarketing(data);
        }
    };
    this.onAcceptConfirmMarketing = function(callback) {
        if (typeof callback == 'function') {
            this.callbackConfirmMarketing = callback;
        }
    };
    this.sendCallbackConfirmMarketing = function(data) {
        if (typeof this.callbackConfirmMarketing == 'function') {
            this.callbackConfirmMarketing(data);
        }
    };
    this.onCancelMarketing = function(callback) {
        if (typeof callback == 'function') {
            this.callbackCancelMarketing = callback;
        }
    };
    this.sendCallbackCancelMarketing = function(data) {
        if (typeof this.callbackCancelMarketing == 'function') {
            this.callbackCancelMarketing(data);
        }
    };
    //#endregion event
}
